/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: StatusDef.ts
 * Created by: Kevin
 * Create Date: 2022-11-14 17:02
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

export enum StatusDef {
    Unknown,
    Success,

// ------------------------------------------------------------------------------------

    ErrError = -89999,
    ErrFailure,
    ErrFailed,
    ErrFatal,
    ErrInternal,
    ErrNilPtr,
    ErrInconsistentSize,
    ErrInvalidData,
    ErrInvalidDataType,
    ErrInvalidProtoData,
    ErrInvalidToken,
    ErrInvalidAccessKey,
    ErrInvalidParams,
    ErrInvalidPath,
    ErrMakeDir,
    ErrPermissionDenied,
    ErrInvalidCommandId,
    ErrNotFound,
    ErrUnsupported,
    ErrOperationFail,
    ErrInvalidPassword,
    ErrInvalidIdOrPassword,
    ErrSystemError,
    ErrNetworkError,
    ErrNetworkRead,
    ErrNetworkWrite,
    ErrNetworkResourceUnavailable,
    ErrNetworkAddrParse,
    ErrTimeout,
    ErrInvalidNetAddr,
    ErrInvalidRemoteNetAddr,
    ErrInvalidLocalNetAddr,
    ErrInvalidDomain,
    ErrInvalidIPAddr,
    ErrInvalidDNSRecord,
    ErrInvalidMode,
    ErrCryptoError,
    ErrCryptoEncryptionFail,
    ErrCryptoDecryptionFail,
    ErrCryptoInvalidKey,
    ErrCryptoKeyGen,
    ErrServerMissingTeamCtrl,
    ErrServerMissingTeam,
    ErrServerMissingRelay,
    ErrServerMissingStun,
    ErrSerialize,
    ErrDeserialize,
    ErrInitialize,
    ErrNotInitialized,
    ErrFinalize,
    ErrAlreadyStart,
    ErrHexEncode,
    ErrHexDecode,
    ErrFileWrite,
    ErrFileRead,
    ErrFileOpen,
    ErrFileClose,
    ErrFileCreate,
    ErrFileDelete,
    ErrFileRename,
    ErrFileCopy,
    ErrFileMove,
    ErrFileFlush,
    ErrNotAvailable,
    ErrFileNotFound,
    ErrDatasource,
    ErrInvalidCert,
    ErrLoadCert,
    ErrCertValidation,
    ErrValidationFail,
    ErrLoadX509PublicKey,
    ErrLoadX509PrivateKey,
    ErrServerNotFound,
    ErrNoRegister,
    ErrNotReady,
    ErrCastFail,
    ErrDbPrepareStmt,
    ErrDbRowScan,
    ErrGenerateToken,
    ErrUnestablished,
    ErrMkdir,
    ErrPersistent,
    ErrUnauthorized,
    ErrOpen,
    ErrExpired,
    ErrMismatch,
    ErrInvalidStatus,
    ErrAlreadyExists,
    ErrAlreadyInitialized,
    ErrUnsupportedFormat,
    ErrUnsupportedEncoding,
    ErrDuplicateKey,
    ErrInvalidDataFormat,
    ErrEmptyData,
    ErrZeroDataSize,
    ErrInadequateSize,
    ErrIndexOutOfBounds,
    ErrInvalidDataSize,
    ErrNotStarted,
    ErrNewFile,
    ErrNotOpen,
    ErrUnWritable,
    ErrUnReadable,
    ErrAlreadyOpened,
    ErrInvalidIndex,
    ErrUnknown,
    ErrInvalidVersion,
    ErrVersionMismatch,
    ErrCycled,
    ErrEncoding,
    ErrDecoding,
    ErrAlreadyConnected,
    ErrInvalidResponse,
    ErrInvalidResponseData,
    ErrInvalidRequest,
    ErrInvalidRequestData,
    ErrInvalidResource,
    ErrResourceNotFound,
    ErrResourceNotAvailable,
    ErrCanceled,
    ErrInvalid,
    ErrConnect,
    ErrInUsing,
    ErrNotImplement,
    ErrNetworkTimeout,
    ErrDisconnect,
    ErrAlreadyJoined,
    ErrLoadData,
    ErrPrepareData,
    ErrBlocked,
    ErrBlockedByUser,
    ErrBlockedBySystem,
    ErrRejected,
    ErrRejectedByUser,
    ErrRejectedBySystem,
    ErrWait,
    ErrWaitFroApproval,
    ErrDataNotFound,
    ErrMetadataNotFound,
    ErrAlready,
    ErrDbTxBegin,
    ErrDbTxCommit,
    ErrDbTxRollback,
    ErrDbExecute,
    ErrDbQuery,
    ErrInvalidChecksum,
    ErrDbNoAffectedRows,
    ErrInterrupted,
    ErrNoSys,
    ErrClosed,
    ErrDataNotEnough,
    ErrNetworkNoSuchHost,
    ErrNetworkServerMisbehaving,
    ErrNotEnoughMemory,
    ErrAborted,
    ErrFormat,
    ErrInvalidIPPacket,
    ErrNetNatRecordNotFound,
    ErrNetLayerNotFound,
    ErrUnsupportedNetworkData,
    ErrIO,
    ErrIoPending,
    ErrIoError,
    ErrIoEOF,
    ErrIoDevice,
    ErrNotRegistered,
    ErrInvalidState,
    ErrAuthenticationRequested,
    StErrUnsupportedVersion,
    StErrThreadAttachFailed,
    StErrThreadDetachFailed,
    StErrNetworkUnreachable,
    StErrNetworkConnection,
    StErrNetworkConnectionRefused,
    StErrNetworkConnectionReset,
    StErrNetworkConnectionAborted,
    StErrNoSuchKey,
    StErrConflict,
    StErrUnexpectedEOF,
    StErrNotEmpty,
    StErrBadDigest,
    StErrInvalidDigest,
    StErrInvalidRange,
    StErrPreconditionFailed,
}

export class StatusDefHelper {

    public static as(st: StatusDef): string {
        return StatusDef[st] + "(" + st.valueOf() + ")";
    }

}